import React from 'react'
import "../assets/loader.css"
const Loading = () => {

    return (
       <>
           <div className="loading">
               <div className="circle"></div>
           </div>
       </>
    )
}

export default Loading